var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"10px","width":"1000px","margin":"0 auto","padding":"0 20px"}},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }